import { render } from "./share-open.vue?vue&type=template&id=40e4bb33"
import script from "./share-open.vue?vue&type=script&lang=js"
export * from "./share-open.vue?vue&type=script&lang=js"

import "./share-open.vue?vue&type=style&index=0&id=40e4bb33&lang=scss"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__